import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { RepositoryActionTypes, RepositoryActionUpdateField } from 'store/repository'
import { EntityType, NegotiationFieldMeta } from 'api'

import { BTQAction } from 'epics'
import { AxeActions } from 'api/AxeAction'
import { AxeFieldNamePrefix, AxeFieldNames } from 'view/routes/axeBoard/components/AxeGridFields'
import { isNil } from 'lodash'

const fieldMap: { [key: string]: NegotiationFieldMeta } = {
  [AxeFieldNames.COLLATERAL]: NegotiationFieldMeta.COLLATERAL,
  [AxeFieldNames.COLLATERAL_BASKET]: NegotiationFieldMeta.BASKET,
  [AxeFieldNames.RESPONDER_ORGANISATION_IDS]: NegotiationFieldMeta.RESPONDER_ORGANISATION_IDS,
  [AxeFieldNames.CURRENCY]: NegotiationFieldMeta.CURRENCY,
  [AxeFieldNames.DIRECTION]: NegotiationFieldMeta.DIRECTION,
  [AxeFieldNames.END_DATE]: NegotiationFieldMeta.END_DATE,
  [AxeFieldNames.NOTIONAL]: NegotiationFieldMeta.NOTIONAL,
  [AxeFieldNames.REPO_TYPE]: NegotiationFieldMeta.REPO_TYPE,
  [AxeFieldNames.START_CONSIDERATION]: NegotiationFieldMeta.START_CONSIDERATION,
  [AxeFieldNames.START_DATE]: NegotiationFieldMeta.START_DATE,
  [AxeFieldNames.TERM]: NegotiationFieldMeta.TERM,
  [AxeFieldNames.RATE]: NegotiationFieldMeta.RATE,
  [AxeFieldNames.FEE]: NegotiationFieldMeta.FEE,
  [AxeFieldNames.REFERENCE_RATE]: NegotiationFieldMeta.REFERENCE_RATE
}

const lookupNegotiationFieldName = (fieldName: string): NegotiationFieldMeta => fieldMap[`${AxeFieldNamePrefix}.${fieldName}`]

export function axeModifyEpic(action$: Observable<BTQAction>): Observable<BTQAction> {
  return action$.pipe(
    ofType<BTQAction, RepositoryActionTypes.REPOSITORY_UPDATE_FIELD, RepositoryActionUpdateField>(
      RepositoryActionTypes.REPOSITORY_UPDATE_FIELD
    ),
    filter(action => action.payload.entityType === EntityType.AXE),
    // in the case instrument has been updated, then we do not need to send the
    // nulled collateral / collateral basket as the api will do this for us
    // we do dispatch both updates in the UI so that the instrument is updated
    // immediately since it is derived from only one of collateral or basket being set
    // and not both concurrently
    filter(
      ({ payload: { fieldName, fieldValue } }) =>
        !(
          [NegotiationFieldMeta.COLLATERAL, NegotiationFieldMeta.BASKET].includes(lookupNegotiationFieldName(fieldName)) &&
          isNil(fieldValue)
        )
    ),
    map(({ meta, payload: { fieldName, fieldValue, entityId, correlationId } }) => {
      const negotiationFieldName = lookupNegotiationFieldName(fieldName)

      return AxeActions.updateAttributes(
        {
          axeId: entityId,
          updatedValues: { [negotiationFieldName]: fieldValue }
        },
        meta.sourceWindowId,
        correlationId
      )
    })
  )
}
